(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const params = new URLSearchParams(window.location.search);
    if (window.location.pathname !== '/collections/color-gels' || params.get('nove_open_brand') !== '1') return;
        if (!window.matchMedia('(min-width: 769px)').matches) return;


    const revealBrandFilter = () => {
      const container = document.querySelector('filter-container.filter-container');
      if (!container) return;

      if (!container.classList.contains('filter-container--show-filters-desktop')) {
        const trigger = container.closest('.shopify-section')?.querySelector('[data-toggle-filters]');
        if (trigger) trigger.click();
      }

      const brandHeading = [...container.querySelectorAll('.filter-group__heading')].find(
        (heading) => heading.querySelector('.filter-group__heading__text')?.textContent.trim() === 'Brand'
      );
      if (brandHeading?.classList.contains('toggle-target-toggler--is-hidden')) brandHeading.click();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealBrandFilter, { once: true });
    } else {
      revealBrandFilter();
    }
  })();

  (() => {
    const sortValues = new Set(['discount-ascending', 'discount-descending']);

    class NoveDiscountSort extends HTMLElement {
      static cache = new Map();

      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.status = this.querySelector('[data-nove-discount-sort-status]');
        this.syncControls();
        const sort = new URL(window.location.href).searchParams.get('sort_by');
        if (this.isDiscountSort(sort)) this.load(window.location.href, true, true);
      }

      isDiscountSort(sort) {
        return sortValues.has(sort);
      }

      labelFor(sort) {
        return sort === 'discount-ascending' ? this.dataset.lowLabel : this.dataset.highLabel;
      }

      announce(message) {
        if (this.status) this.status.textContent = message;
      }

      syncControls() {
        const sort = new URL(window.location.href).searchParams.get('sort_by');
        this.querySelectorAll('[data-nove-discount-sort]').forEach((link) => {
          link.classList.toggle('link-dropdown__link--active', link.dataset.noveDiscountSort === sort);
        });
        this.querySelectorAll('input[name="sort_by"]').forEach((input) => {
          const isActive = input.value === sort;
          if (this.isDiscountSort(input.value)) {
            input.checked = isActive;
            input.closest('.filter-group__item')?.classList.toggle('filter-group__item--active', isActive);
          } else if (this.isDiscountSort(sort)) {
            input.checked = false;
            input.closest('.filter-group__item')?.classList.remove('filter-group__item--active');
          }
        });
        if (this.isDiscountSort(sort)) {
          const buttonText = this.querySelector('.link-dropdown__button-text');
          if (buttonText) buttonText.textContent = this.labelFor(sort);
        }
      }

      buildCacheKey(url) {
        const key = new URL(url);
        key.searchParams.delete('page');
        key.searchParams.delete('section_id');
        key.searchParams.delete('sort_by');
        key.searchParams.sort();
        return `${key.pathname}?${key.searchParams.toString()}`;
      }

      buildSectionUrl(url, page) {
        const sectionUrl = new URL(url);
        sectionUrl.searchParams.set('sort_by', 'created-descending');
        sectionUrl.searchParams.set('page', String(page));
        sectionUrl.searchParams.set('section_id', this.dataset.sectionId);
        return sectionUrl;
      }

      async fetchSection(url, signal) {
        const response = await fetch(url, { method: 'get', signal });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const text = await response.text();
        return new DOMParser().parseFromString(text, 'text/html');
      }

      pageCount(documentNode) {
        let pages = 1;
        documentNode.querySelectorAll('.pagination__link').forEach((link) => {
          const page = Number(new URL(link.href, window.location.origin).searchParams.get('page') || 1);
          if (page > pages) pages = page;
        });
        return pages;
      }

      async collect(url, signal) {
        const firstDocument = await this.fetchSection(this.buildSectionUrl(url, 1), signal);
        const pages = this.pageCount(firstDocument);
        const remaining = [];
        for (let page = 2; page <= pages; page += 1) {
          remaining.push(this.fetchSection(this.buildSectionUrl(url, page), signal));
        }
        const documents = [firstDocument, ...(await Promise.all(remaining))];
        const products = documents.flatMap((documentNode) => (
          [...documentNode.querySelectorAll('product-block[data-nove-discount-sort-value]')].map((product, index) => ({
            html: product.outerHTML,
            discount: Number(product.dataset.noveDiscountSortValue || 0),
            title: product.dataset.noveDiscountSortTitle || '',
            id: product.dataset.productId || '',
            nativeIndex: index
          }))
        ));
        const containers = [...firstDocument.querySelectorAll('[data-ajax-container]')].map((container) => container.innerHTML);
        return { containers, products };
      }

      sortProducts(products, direction) {
        const multiplier = direction === 'discount-ascending' ? 1 : -1;
        return [...products].sort((a, b) => {
          const aValid = a.discount > 0;
          const bValid = b.discount > 0;
          if (aValid !== bValid) return aValid ? -1 : 1;
          if (a.discount !== b.discount) return (a.discount - b.discount) * multiplier;
          const titleOrder = a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true });
          if (titleOrder !== 0) return titleOrder;
          if (a.id !== b.id) return a.id.localeCompare(b.id);
          return a.nativeIndex - b.nativeIndex;
        });
      }

      paginationLink(url, page, className, text) {
        const link = document.createElement('a');
        const linkUrl = new URL(url);
        if (page === 1) {
          linkUrl.searchParams.delete('page');
        } else {
          linkUrl.searchParams.set('page', String(page));
        }
        link.className = className;
        link.href = `${linkUrl.pathname}${linkUrl.search}`;
        link.textContent = text;
        return link;
      }

      renderPagination(container, url, currentPage, totalPages) {
        container.innerHTML = '';
        if (totalPages <= 1) return;
        const pagination = document.createElement('div');
        pagination.className = 'pagination';
        const separator = () => {
          const span = document.createElement('span');
          span.className = 'pagination__sep';
          span.textContent = '·';
          return span;
        };
        if (currentPage > 1) {
          pagination.append(this.paginationLink(
            url,
            currentPage - 1,
            'pagination__prev pagination__link text-current underline underline--on-hover',
            `« ${this.dataset.previousLabel}`
          ));
          pagination.append(separator());
        }
        for (let page = 1; page <= totalPages; page += 1) {
          const number = document.createElement('span');
          number.className = `pagination__number${page === currentPage ? ' underline underline--not-link' : ''}`;
          if (page === currentPage) {
            number.textContent = String(page);
          } else {
            number.append(this.paginationLink(
              url,
              page,
              'pagination__link text-current underline underline--on-hover',
              String(page)
            ));
          }
          pagination.append(number);
        }
        if (currentPage < totalPages) {
          pagination.append(separator());
          pagination.append(this.paginationLink(
            url,
            currentPage + 1,
            'pagination__next pagination__link text-current underline underline--on-hover',
            `${this.dataset.nextLabel} »`
          ));
        }
        container.append(pagination);
      }

      render(data, url, direction, initialLoad) {
        const section = this.closest('.shopify-section');
        const currentContainers = [...section.querySelectorAll('[data-ajax-container]')];
        data.containers.forEach((content, index) => {
          if (currentContainers[index]) currentContainers[index].innerHTML = content;
        });
        const sorted = this.sortProducts(data.products, direction);
        const pageSize = Number(this.dataset.pageSize);
        const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
        const requestedPage = Number(new URL(url).searchParams.get('page') || 1);
        const currentPage = Math.min(Math.max(requestedPage, 1), totalPages);
        const grid = this.querySelector('.collection-listing .product-grid');
        if (grid) {
          const start = (currentPage - 1) * pageSize;
          grid.innerHTML = sorted.slice(start, start + pageSize).map((product) => product.html).join('');
        }
        const pagination = this.querySelector('.pagination-row');
        if (pagination) this.renderPagination(pagination, url, currentPage, totalPages);
        const filterContainer = this.querySelector('filter-container');
        if (filterContainer?.initFiltersEtc) filterContainer.initFiltersEtc();
        this.syncControls();
        if (!initialLoad) {
          const utilityBar = section.querySelector('[data-ajax-scroll-to]');
          const header = document.querySelector('.section-header');
          if (utilityBar && header) {
            const top = utilityBar.getBoundingClientRect().top + window.scrollY - header.clientHeight;
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top, behavior: reducedMotion ? 'auto' : 'smooth' });
          }
        }
      }

      async load(url, noPushState = false, initialLoad = false) {
        const target = new URL(url, window.location.origin);
        const direction = target.searchParams.get('sort_by');
        if (!this.isDiscountSort(direction)) return;
        target.searchParams.delete('section_id');
        if (!noPushState) window.history.pushState({ path: target.href }, '', target.href);
        this.syncControls();
        this.announce(this.dataset.loadingText);
        this.querySelectorAll('[data-ajax-container]').forEach((container) => container.classList.add('ajax-loading'));
        if (this.abortController) this.abortController.abort('Existing request not needed');
        this.abortController = new AbortController();
        try {
          const key = this.buildCacheKey(target);
          let data = NoveDiscountSort.cache.get(key);
          if (!data) {
            data = await this.collect(target, this.abortController.signal);
            NoveDiscountSort.cache.set(key, data);
          }
          this.render(data, target, direction, initialLoad);
          this.announce(`${this.dataset.completeText} ${this.labelFor(direction)}.`);
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.announce(this.dataset.errorText);
            console.warn(error);
          }
        } finally {
          this.querySelectorAll('[data-ajax-container]').forEach((container) => container.classList.remove('ajax-loading'));
        }
      }
    }

    if (!customElements.get('nove-discount-sort')) {
      customElements.define('nove-discount-sort', NoveDiscountSort);
    }

    customElements.whenDefined('filter-container').then(() => {
      const FilterContainer = customElements.get('filter-container');
      if (FilterContainer.prototype.noveDiscountSortPatched) return;
      const originalAjaxLoadUrl = FilterContainer.prototype.ajaxLoadUrl;
      FilterContainer.prototype.ajaxLoadUrl = function ajaxLoadUrl(url, noPushState) {
        const discountSort = this.closest('nove-discount-sort');
        const sort = new URL(url, window.location.origin).searchParams.get('sort_by');
        if (discountSort?.isDiscountSort(sort)) return discountSort.load(url, noPushState);
        return originalAjaxLoadUrl.call(this, url, noPushState);
      };
      FilterContainer.prototype.noveDiscountSortPatched = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nove-gel-color-finder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nove-gel-color-finder]').forEach((finder) => {
    if (finder.dataset.ready) return;
    finder.dataset.ready = 'true';

    const box = finder.querySelector('.nove-gel-finder__box');
    const loading = finder.querySelector('.nove-gel-finder__loading');
    const list = finder.querySelector('.nove-gel-finder__swatches');

    fetch(finder.dataset.source)
      .then((response) => {
        if (!response.ok) throw new Error('Color filter data was unavailable.');
        return response.json();
      })
      .then((data) => {
        if (!Array.isArray(data.values) || data.values.length === 0) throw new Error('No color filter values were returned.');

        data.values.forEach((value) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          const swatch = document.createElement('span');
          const label = document.createElement('span');
          const arrow = document.createElement('span');

          link.className = 'nove-gel-finder__swatch-link';
          const destination = new URL(value.url, window.location.origin);
          destination.searchParams.set('nove_open_brand', '1');
          link.href = `${destination.pathname}${destination.search}${destination.hash}`;
          swatch.className = 'nove-gel-finder__swatch';
          swatch.setAttribute('aria-hidden', 'true');
          label.className = 'nove-gel-finder__label';
          label.textContent = value.label;
          arrow.className = 'nove-gel-finder__arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.innerHTML = '&rarr;';

          if (value.color) swatch.style.backgroundColor = `rgb(${value.color})`;
          if (value.image) swatch.style.backgroundImage = `url("${value.image}")`;

          link.append(swatch, label, arrow);
          item.append(link);
          list.append(item);
        });

        loading.hidden = true;
        list.hidden = false;
        box.setAttribute('aria-busy', 'false');
      })
      .catch(() => {
        finder.hidden = true;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
